module.exports = __webpack_public_path__ + "static/media/dev-core-services.8088f889.png";